import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { ROUTES } from '@/shared/config';
import { PageLayout } from '@/shared/ui';
import { TopicsListSkeleton } from '@/widgets/topics-list';

/**
 * Экраны на время загрузки чанка (`lazyPage` в `app/router`): те же шапки,
 * вкладки фильтра и сетка скелетов, что `TopicsList` показывает до данных, —
 * загрузка кода и данных идёт одним шиммером.
 */
export function RoleplayAllPageSkeleton() {
  const { t } = useTranslation('TopicsAllPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('roleplayTitle')} onBack={() => void navigate(ROUTES.home)}>
      <TopicsListSkeleton />
    </PageLayout>
  );
}

export function IdiomAllPageSkeleton() {
  const { t } = useTranslation('TopicsAllPage');
  const navigate = useNavigate();
  return (
    <PageLayout title={t('idiomTitle')} onBack={() => void navigate(ROUTES.home)}>
      <TopicsListSkeleton />
    </PageLayout>
  );
}
